import React, { useRef, useState, useEffect } from 'react'
import WhiteArrowSvg from '../../Common/svg/whiteArrow';
import ArrowTop from '../../Common/svg/arrowtop';
import { useMutation } from 'react-query';
import { updateDelivery } from '../../../MyApi/delivery';
import Swal from 'sweetalert2';

const ShippingAttachments = ({logo, id, refetch}) => {
    const logoInputRef = useRef();
    const [logoFile, setLogoFile] = useState(null);
    const [logoPreview, setLogoPreview] = useState(logo);
    const [isSaving, setIsSaving] = useState(false);
    const [hasChanges, setHasChanges] = useState(false);

    const mutation = useMutation({
        mutationKey: ["updateDelivery"],
        mutationFn: (formData) => updateDelivery(formData, id),
        onSuccess: () => {
            setIsSaving(false);
            setHasChanges(false);
            Swal.fire({
                icon: "success",
                title: "تم الحفظ بنجاح",
                text: "تم تحديث صورة شعار شركة الشحن بنجاح",
            });
            refetch();
        },
        onError: (error) => {
            setIsSaving(false);
            Swal.fire({
                icon: "error",
                title: "خطأ",
                text: "حدث خطأ أثناء تحديث الصورة",
            });
            console.error("Update error:", error);
        },
    });

    useEffect(() => {
        setLogoPreview(logo);
        setLogoFile(null);
        setHasChanges(false);
    }, [logo]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Validate file type
            const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/gif", "image/svg+xml"];
            if (!ALLOWED_TYPES.includes(file.type)) {
                Swal.fire({
                    icon: "error",
                    title: "نوع الصورة غير مسموح به",
                    text: "الرجاء اختيار صورة بتنسيق JPG, PNG, JPEG, GIF, أو SVG",
                });
                e.target.value = "";
                return;
            }

            // Validate file size (2MB limit)
            const MAX_FILE_SIZE = 2 * 1024 * 1024;
            if (file.size > MAX_FILE_SIZE) {
                Swal.fire({
                    icon: "error",
                    title: "حجم الصورة كبير جداً",
                    text: "حجم الصورة يجب ألا يزيد عن 2 ميجا",
                });
                e.target.value = "";
                return;
            }

            const url = URL.createObjectURL(file);
            setLogoPreview(url);
            setLogoFile(file);
            setHasChanges(true);
        }
    };

    const handleSave = () => {
        if (!logoFile) {
            Swal.fire({
                icon: "warning",
                title: "لا توجد تغييرات",
                text: "يرجى اختيار صورة جديدة قبل الحفظ",
            });
            return;
        }

        setIsSaving(true);
        const formData = new FormData();
        formData.append("_method", "PUT");
        formData.append("store[logo]", logoFile);
        
        mutation.mutate(formData);
    };

    const handleReset = () => {
        setLogoPreview(logo);
        setLogoFile(null);
        setHasChanges(false);
        if (logoInputRef.current) {
            logoInputRef.current.value = "";
        }
    };

    return (
        <div className="row">
            <div className="col-12">
                <h5 className="font14 mb-2">صورة اللوجو</h5>
                
                <div
                    className="flex-grow-1 border rounded-4 text-center upload-box position-relative"
                    style={{ cursor: "pointer", minWidth: "250px" }}
                    onClick={() => logoInputRef.current && logoInputRef.current.click()}
                >
                    {logoPreview ? ( 
                        <div className="relative w-100 ratio ratio-1x1">
                            <img src={logoPreview} className="w-100 h-100 object-fit-contain rounded-4" alt="Logo" />
                            <div className="overLay w-100 h-100 rounded-4">
                                <div>
                                    <WhiteArrowSvg />
                                    <h5 className="text-white"> تغيير صورة اللوجو</h5>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <>
                            <ArrowTop />
                            <h6 className="fw-bold mb-1">تحميل صورة اللوجو</h6>
                            <p className="text-muted small mb-0">
                                (JPG / PNG) ارفع صورة بجودة عالية
                            </p>
                            <p className="text-muted small mb-0">الأبعاد 1:1</p>
                        </>
                    )}
                    
                    <input
                        ref={logoInputRef}
                        type="file"
                        accept="image/png, image/jpeg"
                        hidden
                        onChange={handleFileChange}
                    />
                </div>

                {logoFile && (
                    <p className="mt-2 text-success small">
                        {logoFile.name}
                    </p>
                )}

                {hasChanges && (
                    <div className="d-flex gap-2 align-items-center mt-4">
                        <button
                            className="btn btn-primary"
                            onClick={handleSave}
                            disabled={isSaving}
                        >
                            {isSaving ? "جاري الحفظ..." : "حفظ التغييرات"}
                        </button>
                        <button
                            className="btn btn-white"
                            onClick={handleReset}
                            disabled={isSaving}
                        >
                            إعادة ضبط
                        </button>
                    </div>
                )}
            </div>
        </div>
    )   
}

export default ShippingAttachments
